import {useEffect, useState} from 'react';

/**
 * If we try to access the above store directly in the component,
 *  we'll get hydration errors if the user is logged in because it doesn't match the initial state of the store.
 * We will get hydration errors because Zustand contains data from persist middleware (Local Storage, etc...)
 * while the hydration is not complete and the server-rendered store has initial state values,
 *  resulting in a mismatch in the store's state data.
 *
 * @see - https://dev.to/abdulsamad/how-to-use-zustands-persist-middleware-in-nextjs-4lb5?comments_sort=oldest
 * @param store
 * @param callback
 * @returns
 */
export const useStore = <T, F>(store: (callback: (state: T) => unknown) => unknown, callback: (state: T) => F) => {
  const result = store(callback) as F;
  const [data, setData] = useState<F>();

  useEffect(() => {
    setData(result);
  }, [result]);

  return data;
};
